// Styles
import styled, { css } from 'styled-components';
import { variantTypography } from './types';

interface ContainerProps {
  variant: variantTypography;
  state: boolean;
}

export const Container = styled.div<ContainerProps>`
  ${({ variant, state, theme }) =>
    ({
      normal: css`
        background-color: none;
      `,
      labeled: css`
        display: flex;
        align-items: center;
        gap: ${theme.spaces.xxs}rem;
        padding: 6px 10px;
        border-radius: 50px;
        background-color: ${state ? theme.colors.garnetLight : theme.colors.greyLight};
      `,
    })[variant]}
`;

export const SwitchSimple = styled.label<ContainerProps>`
  ${({ variant, state, theme }) =>
    ({
      normal: css`
        background-color: ${state ? theme.colors.lightDustyRose : theme.colors.greyLight};
      `,
      labeled: css`
        background-color: ${theme.colors.greyVeryLight};
      `,
    })[variant]}

  position: relative;
  display: flex;
  align-items: center;
  border-radius: 3.4rem;
  transition: 0.4s;
  align-items: center;
  width: 3.4rem;
  height: 1.4rem;
  cursor: pointer;

  &:before {
    content: '';
    height: 2rem;
    width: 2rem;
    background-color: ${({ theme }) => theme.colors.black};
    border-radius: 50%;
    transition: 0.4s;
    margin-left: ${({ state }) => (state ? `1.4rem` : 0)};
  }
`;

export const InputSimple = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
`;
